import { createClient } from '@supabase/supabase-js';

// Same Supabase project as the `marketing` client, but pinned to the `public`
// schema so we can read raw Petpooja tables (petpooja_orders, order_items,
// sales, customers, CRM) without going through a marketing.* view.
//
// Default data path remains the marketing client + materialized views — only
// reach for this when you genuinely need raw Petpooja data (e.g. CRM
// customer history, individual order rows, audit lookups).
const url = import.meta.env.VITE_SUPABASE_MARKETING_URL;
const key = import.meta.env.VITE_SUPABASE_MARKETING_ANON_KEY;

export const inventory = createClient(url ?? 'http://localhost', key ?? 'anon', {
  auth: { persistSession: false },
  db: { schema: 'public' },
});
